__turbopack_context__.v({
  "linksContainer": "linksPanelButton-module-scss-module__QYRKvW__linksContainer",
});
